interface Props {
    color?: string;
    scale?: number;
}

const ZigZag = ({ color = 'black', scale = 1 }: Props) => {
    return (
        <svg
            width="100%"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 500 ${32 * scale}`}
        >
            <g transform={`scale(1, ${scale})`}>
                <path fill={color} fill-rule="evenodd" clip-rule="evenodd" d="M0 0L17.8571 17.955L35.7143 0L53.5714 17.955L71.4286 0L89.2857 17.955L107.143 0L125 17.955L142.857 0L160.714 17.955L178.571 0L196.429 17.955L214.286 0L232.143 17.955L250 0L267.857 17.955L285.714 0L303.571 17.955L321.429 0L339.286 17.955L357.143 0L375 17.955L392.857 0L410.714 17.955L428.571 0L446.429 17.955L464.286 0L482.143 17.955L500 0V32H250H0V0Z"/>
            </g>
        </svg>
    )
}

export default ZigZag;
